










































// JS对象深度合并
function setClipboardData(obj = {}) {
	uni.setClipboardData({
		...obj
	});
}

export default setClipboardData;
